import React from "react";

const ParameterGauge = ({
  title,
  value,
  unit,
  minValue,
  maxValue,
  normalMin,
  normalMax,
  colorLow,
  colorNormal,
  colorHigh,
}) => {
  // Calculate position on the scale (0-100%)
  const getPosition = (val) => {
    const percentage = ((val - minValue) / (maxValue - minValue)) * 100;
    return Math.max(0, Math.min(100, percentage));
  };

  // Determine color based on value
  const getColor = (val) => {
    if (val < normalMin) return colorLow;
    if (val > normalMax) return colorHigh;
    return colorNormal;
  };

  const position = getPosition(value);
  const color = getColor(value);

  return (
    <div className="bg-white/5 p-4 rounded-lg border border-white/10 backdrop-blur-sm">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-semibold text-gray-200">{title}</h3>
        <div className="text-xl font-bold" style={{ color }}>
          {value.toFixed(1)} <span className="text-sm font-normal text-gray-300">{unit}</span>
        </div>
      </div>

      <div className="relative h-4 bg-gray-700/50 rounded-full">
        {/* Normal range indicator */}
        <div
          className="absolute top-0 h-4 bg-green-500/20 border border-green-400/30 rounded-full"
          style={{
            left: `${getPosition(normalMin)}%`,
            width: `${getPosition(normalMax) - getPosition(normalMin)}%`,
          }}
        ></div>

        {/* Value indicator */}
        <div
          className="absolute top-0 w-3 h-4 -ml-1.5 rounded-full shadow-lg"
          style={{ left: `${position}%`, backgroundColor: color }}
        ></div>
      </div>

      <div className="flex justify-between mt-1 text-xs text-gray-400">
        <span>{minValue}</span>
        <span>{normalMin}</span>
        <span>{normalMax}</span>
        <span>{maxValue}</span>
      </div>
    </div>
  );
};

export default ParameterGauge;
